export default __webpack_public_path__ + "static/media/640_business04-jp-mobile.d0027d42.png";